// src/layout/AppLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import BottomNav from "./BottomNav";

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="grid grid-cols-1 md:grid-cols-[260px_1fr]">
        <aside className="hidden md:block border-r bg-white min-h-screen">
          <Sidebar />
        </aside>

        <main className="min-h-screen">
          <header className="border-b bg-white p-4 md:hidden">
            <h1 className="text-lg font-semibold tracking-tight">Hippolyte</h1>
          </header>

          {/* ⬇️ padding identique pour toutes les pages */}
          <div className="p-4 md:p-8">
            <Outlet />
          </div>
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
